import React, { Component, Fragment } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import axios from 'axios';

  

export class LoginMenu extends Component {
  constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            name: null,
          userName: null,
          role:null
        };
    
    }

 
    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
      console.log(user)
      console.log(isAuthenticated)
      console.log(authService)

        this.setState({
            isAuthenticated,
            name: user && user.name ,
          userName: user && user.name
        });
      console.log(user)
      if (this.state.userName !==null) {
        this.GetUserCurrent(user.sub)
      }
    
    }

  GetUserCurrent(idEmpleado){
      if (idEmpleado!==null) {


     
  axios.get('/Api/Usuario/UsuarioRole?idEmpleado=' + idEmpleado)
      .then(response => {
        console.log(response);
          console.log(response.data);
          if (response.data.length>0) {
              this.setState({ role: response.data[0].role })

          }
      
        console.log(this.state)
        
      })
      .catch(function (error) {
        console.log(error);
      })
      }
  }

 


    render() {
      const { isAuthenticated, name, userName } = this.state;
     
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            return this.authenticatedView(name, userName, profilePath, logoutPath);
        }
    }

  authenticatedView(name, userName, profilePath, logoutPath) {
      if (this.state.role == "Admin" ) {

      return (<Fragment>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to="/">Inicio</NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to="/RevisarCreditosAdmin">Solicitudes</NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to={profilePath}>Perfil</NavLink>
          </NavItem>
          <NavItem>
              <a className="text-dark nav-link" href="/identity/admin/index">Administración</a>
          </NavItem>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to={logoutPath}>Salir</NavLink>
        </NavItem>
      </Fragment>);

      }

      else if (this.state.role == "Vendedor" || this.state.role == "Analista de Crédito") {

          return (<Fragment>
              <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/">Inicio</NavLink>
              </NavItem>
              <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/RevisarCreditosAdmin">Solicitudes</NavLink>
              </NavItem>
              <NavItem>
                  <NavLink tag={Link} className="text-dark" to={profilePath}>Perfil</NavLink>
              </NavItem>
              <NavItem>
                  <NavLink tag={Link} className="text-dark" to={logoutPath}>Salir</NavLink>
              </NavItem>
          </Fragment>);
      }
      else {

      return (<Fragment>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to="/">Inicio</NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to="/VerCreditos">Solicitudes</NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to={profilePath}>Perfil</NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={Link} className="text-dark" to={logoutPath}>Salir</NavLink>
        </NavItem>
      </Fragment>);
    }
     

    }

    anonymousView(registerPath, loginPath) {
        return (<Fragment>
            <NavItem>
            <NavLink tag={Link} className="text-dark" to={loginPath}>Iniciar Sesión</NavLink>
            </NavItem>
        </Fragment>);
        //return (null);
    }
}
